import { QueryHookOptions, useQuery } from "@apollo/react-hooks";

import { PropositionAllocation } from "@hubcapp/types";

import instructorAreasQuery from "../graph-ql/instructorAreas.graphql";

const useQueryInstructorAreas = (opts?: QueryHookOptions) =>
  useQuery<{ instructor: { propositions: PropositionAllocation[] } }>(
    instructorAreasQuery,
    {
      /*This is being used because the cache isn't updating due to the result of the createAreaCoverage mutation not fully matching the propositionAllocation type,
      it is now also needed because for some reason, Apollo will use data from the initial productCategory type for other product categories i.e. Motability areas will
      have the coverage from a matching Pre/Post area if they are the same region*/
      fetchPolicy: "no-cache",
      ...opts,
    },
  );

export default useQueryInstructorAreas;
